import React, { memo } from 'react';
import styled from 'styled-components';
import { get } from '../../constants.js';
import Box from '../Box/Box.js';

({
  light: get('colors.elevation.surface.default.[default]'),
  //'#FFFFFF'
  dark: get('colors.elevation.surface.default.[default]') // '#1B2638')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
});
const sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
const smallStyles = {
  width: sizes.small,
  height: sizes.small
};
const mediumStyles = {
  width: sizes.medium,
  height: sizes.medium
};
const largeStyles = {
  width: sizes.large,
  height: sizes.large
};
const xlargeStyles = {
  width: sizes.xlarge,
  height: sizes.xlarge
};

// pre-built css style-size map
const sizeStyleMap = {
  small: smallStyles,
  medium: mediumStyles,
  large: largeStyles,
  xlarge: xlargeStyles
};
const AtlasSvgPrimitive = /*#__PURE__*/memo(function AtlasSvgPrimitive({
  size = 'medium',
  label,
  primaryColor = 'currentColor',
  secondaryColor,
  testId,
  children
}) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    style: {
      color: primaryColor,
      fill: secondaryColor,
      ...sizeStyleMap[size]
    },
    "data-testid": testId,
    "aria-label": label || undefined,
    role: label ? 'img' : 'presentation'
  }, children);
});
styled(Box).withConfig({
  displayName: "AtlasSvgPrimitive__Wrapper",
  componentId: "sc-1ncjkob-0"
})(["--local-background:var(--ds-background-input,#fafbfc);--local-background-active:var(--ds-background-input-pressed,#deebff);--local-background-checked:var(--ds-background-selected-bold,#0052cc);--local-background-checked-hover:var(--ds-background-selected-bold-hovered,#0065ff);--local-background-disabled:var(--ds-background-disabled,#f4f5f7);--local-background-hover:var(--ds-background-input-hovered,#ebecf0);--local-border:var(--ds-border-input,#dfe1e6);--local-border-active:var(--ds-border,#deebff);--local-border-checked:var(--ds-background-selected-bold,#0052cc);--local-border-checked-hover:var(--ds-background-selected-bold-hovered,#0065ff);--local-border-checked-invalid:var(--ds-border-danger,#ff5630);--local-border-disabled:var(--ds-background-disabled,#f4f5f7);--local-border-focus:var(--ds-border-focused,#4c9aff);--local-border-hover:var(--ds-border-input,#dfe1e6);--local-border-invalid:var(--ds-border-danger,#ff5630);--local-tick-active:var(--ds-icon-inverse,#0052cc);--local-tick-checked:var(--ds-icon-inverse,#fafbfc);--local-tick-disabled:var(--ds-icon-disabled,#a5adba);--local-tick-rest:transparent;--checkbox-background-color:var(--local-background-checked);--checkbox-border-color:var(--local-border-checked);--checkbox-tick-color:var(--local-tick-checked);"]);

export { AtlasSvgPrimitive, sizeStyleMap, sizes };
